import React, { useState } from "react"

import MenuItems from "./menuItems"
import * as mainMenu from "../../menus/mainMenu"
import * as beverageMenu from "../../menus/beverageMenu"
import * as cocktailMenu from "../../menus/cocktailMenu"
import * as pizzaMenu from "../../menus/pizzaMenu"

import * as styles from "../../styles/components/menu/menu.module.scss"

//images
// import img1 from "../../images/partnerImage1.png"

const Menu = () => {
  const [type, setType] = useState("Main Menu")
  const [menuData, setMenuData] = useState(mainMenu)
  // const [image, setImage] = useState(img1)

  const typeFilterHandler = e => {
    setType(e.target.value)

    switch (e.target.value) {
      case "Main Menu":
        setMenuData(mainMenu)
        // setImage(img1)
        break
      case "Beverage Menu":
        setMenuData(beverageMenu)
        // setImage(img2)
        break
      case "Cocktail Menu":
        setMenuData(cocktailMenu)
        // setImage(img3)
        break
      case "Pizza Promo":
        setMenuData(pizzaMenu)
        // setImage(img4)
        break
      default:
        setMenuData(mainMenu)
    }
  }

  return (
    <React.Fragment>
      <div className={styles.typeFilter}>
        <div>
          <input
            type="radio"
            checked={type === "Main Menu"}
            value="Main Menu"
            name="typeRadio"
            id="mainRadio"
            onChange={typeFilterHandler}
          />
          <label htmlFor="mainRadio">Main Menu</label>
        </div>
        <div>
          <input
            type="radio"
            checked={type === "Pizza Promo"}
            value="Pizza Promo"
            name="typeRadio"
            id="pizzaRadio"
            onChange={typeFilterHandler}
          />
          <label htmlFor="pizzaRadio">Pizza Promo</label>
        </div>
        <div>
          <input
            type="radio"
            checked={type === "Beverage Menu"}
            value="Beverage Menu"
            name="typeRadio"
            id="beverageRadio"
            onChange={typeFilterHandler}
          />
          <label htmlFor="beverageRadio">Beverage Menu</label>
        </div>
        <div>
          <input
            type="radio"
            checked={type === "Cocktail Menu"}
            value="Cocktail Menu"
            name="typeRadio"
            id="cocktailRadio"
            onChange={typeFilterHandler}
          />
          <label htmlFor="cocktailRadio">Cocktail Menu</label>
        </div>
      </div>

      <div className={styles.wrapper}>
        <div className={styles.menuTitle}>
          {/* <img src={image} alt="image" /> */}
          <h1>{type}</h1>
          <p>OPEN 14:00H TO 04:00H</p>
        </div>
        {menuData.offer && (
          <div className={styles.offer}>
            <h3>{menuData.offer}</h3>
          </div>
        )}
        <div className={styles.menu}>
          {/* Menu Items displayed on the left section */}
          <MenuItems categories={menuData.left} />
          <aside className={styles.aside}>
            {/* Menu Items displayed on the right section */}
            <MenuItems categories={menuData.right} />
          </aside>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Menu
